import type { Video } from '../../api/videos/types'
import type { Document } from '../../api/documents/types'
import type { Event } from '../../api/events/types'
import type { CompanyBrief } from '../../api/companies/types'

export enum SEARCH_RESULT_TYPE {
  VIDEO = 'video',
  DOCUMENT = 'document',
  EVENT = 'event',
  COMPANY = 'company',
}

export interface SearchResult {
  _rankingScore: number
  _type: SEARCH_RESULT_TYPE
}

export type VideoSearchResult = Video & SearchResult
export type DocumentSearchResult = Document & SearchResult
export type EventSearchResult = Event & SearchResult
export type CompanySearchResult = CompanyBrief & SearchResult

export interface SearchResults {
  videos: Array<VideoSearchResult>
  documents : Array<DocumentSearchResult>
  events : Array<EventSearchResult>
  companies : Array<CompanySearchResult>
  all?: SingleListSearchResponse
}

export type SingleListSearchResponse = Array<VideoSearchResult | DocumentSearchResult | EventSearchResult | CompanySearchResult>
